import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Minimal legal disclaimer paragraph. No frame, no icon, no heading — inherits
 * its color from the parent (pass color via className).
 * Kept very compact so it does not affect surrounding layout.
 */
export default function PlatformDisclaimer({ className = '' }) {
  const { language } = useLanguage();
  const es = language === 'es';

  const text = es
    ? 'WakaCasa es una plataforma tecnológica para la gestión documental y verificación asistida por IA. WakaCasa NO es una agencia inmobiliaria, NO brinda asesoría legal, y NO es responsable de las transacciones inmobiliarias. DEBES verificar de forma independiente toda la información con profesionales legales y notariales antes de comprar o vender una propiedad.'
    : 'WakaCasa is a technology platform for document management and AI-assisted verification. WakaCasa is NOT a real estate brokerage, does NOT provide legal advice, and is NOT responsible for property transactions. You MUST independently verify all information through legal and notarial professionals before purchasing or selling property.';

  return (
    <p
      className={`text-[10px] sm:text-[11px] leading-relaxed ${className}`}
      data-testid="platform-disclaimer"
    >
      {text}
    </p>
  );
}
